import axios from "axios";
import { baseUrl } from "../util";

export const getEconomicSupplierData = ({
  filters = null,
  sortBy = null,
  setSuppliers,
  year,
  chosenYear,
  period,
  allocatedYear,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/suppliers-economic",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      ...filters,
      sort_by: sortBy,
      year: year,
      chosenYear: chosenYear,
      period: period,
      allocatedYear: allocatedYear,
    },
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(function (response) {
        setSuppliers(response.data.data.collection);
        resolve(response.data.data.collection);
      })
      .catch(function (error) {
        console.error(error);
        reject(error);
      });
  });
};
